import { apiService } from '@/api/apiService';
import { ApiResponseType, AuthResponseType } from '@/types/sharedTypes';

export type LoginType = {
  email: string;
  recaptcha_response: string;
};

export const LOGIN_URL = '/users/auth/email-identification/';

export const loginApi = (data: LoginType): Promise<ApiResponseType<AuthResponseType>> => {
  return apiService.POST(LOGIN_URL, data);
};
